import { SelectOption } from "@/types/inputField";

export enum FilterCode {
  STATUS = 'status',
  SEASON = 'season',
  SESSION = 'session',
  POST_DATE = 'postDate',
  TO_DATE = 'toDate',
  REPORT_TYPE = 'reportType',
  REPORT = 'reportId'
}

export enum FilterOrOptionType {
  DROPDOWN = 'dropDown',
  TEXTBOX = 'textBox',
  CHECKBOX = 'checkBox',
  JSON = 'json',
  DATE = 'date',
  FIELD_COMPARISON = 'fieldComparison'
}

// Comparison Operators used in Filters
export const ComparisonOperators: SelectOption[] = [
  {
    id: '=',
    value: 'equals'
  },
  {
    id: '<>',
    value: 'not equals'
  },
  {
    id: '<',
    value: 'less than'
  },
  {
    id: '<=',
    value: 'less than or equals to'
  },
  {
    id: '>',
    value: 'greater than'
  },
  {
    id: '>=',
    value: 'greater than or equals to'
  }
]

export enum DateRange { 
  LAST_7_DAYS = '7d',
  LAST_1_MONTH = '1m',
  LAST_3_MONTHS = '3m',
  LAST_1_YEAR = '1y',
  LAST_2_YEARS = '2y'
}
